<template>
  <vi-page>
    <vi-card :title="title">
      <div class="bill_detail">
        <h6>基本信息</h6>
        <div class="row">
          <div class="col-4">
            账单编号：<span>{{ billData.snText }}</span>
          </div>
          <div class="col-4">
            类型：<span>{{ billData.typeText }}</span>
          </div>
          <div class="col-4">
            状态：<span>{{ billData.statusText }}</span>
          </div>

          <div class="col-4">
            创建人：<span>{{ billData.creatorText }}</span>
          </div>
          <div class="col-4">
            创建时间：<span>{{ billData.timeText }}</span>
          </div>
          <div class="col-4">
            更新时间：<span>{{ billData.lastTimeText }}</span>
          </div>
          <div class="col-8">
            备注：<span>{{ billData.memoText }}</span>
          </div>
        </div>
      </div>
      <div class="bill_detail">
        <h6>费用明细</h6>
        <div class="row">
          <div class="col-4">
            原价：
            <vi-amount v-model="billData.originalAmountText" :prefix="prefix" />
          </div>
          <div class="col-4">
            优惠金额：
            <vi-amount v-model="billData.discountAmountText" :prefix="prefix" />
          </div>
          <div class="col-4">
            抹零金额：
            <vi-amount v-model="billData.roundAmountText" :prefix="prefix" />
          </div>
          <div class="col-4">
            应付金额：
            <vi-amount v-model="billData.amountText" :prefix="prefix" />
          </div>
          <div class="col-8">
            税费金额：
            <vi-amount v-model="billData.taxAmountText" :prefix="prefix" />
          </div>
          <div class="col-12">
            账单概要：<span>{{ billData.nameText }}</span>
          </div>
          <div class="col-12">账单明细：</div>
          <div class="col-12">
            {{ billData.detailText }}
          </div>
        </div>
      </div>
      <div class="bill_detail">
        <h6>支付详情</h6>
        <div class="row">
          <div class="col-4">
            支付单号：<span>{{ paymenData.bizNumberText }}</span>
          </div>
          <div class="col-4">
            支付方式：<span>{{ paymenData.typeText }}</span>
          </div>
          <div class="col-4">
            支付状态：<span>{{ paymenData.statusText }}</span>
          </div>
          <div class="col-4">
            支付金额：
            <vi-amount v-model="paymenData.amountText" :prefix="prefix" />
          </div>
          <div class="col-4">
            操作人：<span>{{ paymenData.creatorText }}</span>
          </div>
          <div class="col-4">
            过期时间：<span>{{ paymenData.expiredTimeText }}</span>
          </div>
          <div class="col-4">
            下单时间：<span>{{ paymenData.timeText }}</span>
          </div>
          <div class="col-4">
            更新时间：<span>{{ paymenData.lastTimeText }}</span>
          </div>
        </div>
      </div>
      <vi-card border v-if="offlineShow">
        <template v-slot:title>
          <div class="row align-items-center">
            <span class="ml-4 font-weight-bolder">支付凭证</span>
          </div>
        </template>
        <div class="menu_table">
          <table class="table table-vertical-center">
            <thead>
              <tr>
                <th scope="col">凭证图片</th>
                <th scope="col">凭证内容</th>
                <th scope="col">支付状态</th>
                <th scope="col">操作人</th>
                <th scope="col">上传时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in paymenOrderList" :key="index">
                <td class="payment_img">
                  <div
                    class="image-input-wrapper image-input-default cursor_pointer"
                    @click="ePreview(item.imageUrl)"
                    :style="{
                      'background-image': `url('${eHandleImageURI(
                        item.imageUrl
                      )}')`,
                    }"
                  ></div>
                </td>
                <td>{{ item.content }}</td>
                <td>{{ ePaymentStatus(item.orderStatus) }}</td>
                <td>{{ item.creator.name }}</td>
                <td>{{ eGetTime(item.time) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </vi-card>
    </vi-card>
    <PictureCtrl
      v-if="modalData.addable"
      v-model="modalData.showAdd"
      :modalData="modalData"
      @input="eModalCancel"
    ></PictureCtrl>
  </vi-page>
</template>
<script>
var moment = require("moment");
import PictureCtrl from "@/components/PictureCtrl.vue";
export default {
  name: "PagesDashboardShiyunCostBillDetail",
  components: { PictureCtrl },
  data() {
    return {
      billData: {
        snText: "",
        typeText: "",
        statusText: "",
        periodText: "",
        creatorText: "",
        timeText: "",
        lastTimeText: "",
        manualStatusText: "",
        memoText: "",
        originalAmountText: "",
        discountAmountText: "",
        roundAmountText: "",
        amountText: "",
        taxAmountText: "",
        nameText: "",
        detailText: "",
        billIdText: "",
      },
      prefix: this.$$.currency.prefix(),
      sign: "",
      paymentOrderSN: "",
      paymenData: {
        bizNumberText: "",
        typeText: "",
        statusText: "",
        amountText: "",
        creatorText: "",
        expiredTimeText: "",
        timeText: "",
        lastTimeText: "",
      },
      paymenOrderList: [],
      modalData: {
        addable: false,
        showAdd: false,
        url: "",
      },
      offlineShow: false,
      title:"",
    };
  },
  mounted() {
    this.eGetOrderInfo();
    this.title = `费用账单详情 - ${this.$route.params.sn}`;
  },
  methods: {
    eGetOrderInfo() {
      this.$$.api.data
        .find("/shiyun/marketing/apis/data/shiyunBill", {
          number: this.$route.params.sn,
          columns: ["*", "user.*", "creator.*"],
        })
        .then((res) => {
          let data = res.data.item;
          this.billData.billIdText = data.sn ? data.sn : "";
          this.billData.snText = data.sn ? data.sn : "";
          this.billData.typeText = data.type ? this.eBillType(data.type) : "";
          this.billData.statusText = data.status
            ? this.eBillStatus(data.status)
            : "";
          this.billData.periodText = data.period ? data.period : "";
          this.billData.creatorText = data.creator ? data.creator.name : "";
          this.billData.timeText = data.time ? this.eGetTime(data.time) : "";
          this.billData.lastTimeText = data.lastTime
            ? this.eGetTime(data.lastTime)
            : "";
          this.billData.manualStatusText = data.manualStatus
            ? this.eManualStatus(data.manualStatus)
            : "";
          this.billData.memoText = data.memo ? data.memo : "";
          this.billData.originalAmountText = data.originalAmount;
          this.billData.discountAmountText = data.discountAmount;
          this.billData.roundAmountText = data.roundAmount;
          this.billData.amountText = data.amount;
          this.billData.taxAmountText = data.taxAmount;
          this.billData.nameText = data.name ? data.name : "";
          this.billData.detailText = data.detail ? data.detail : "";
          this.paymentOrderSN = data.paymentOrderSN;
          this.eGetPaymentInfo();
        });
    },
    eBillType(type) {
      let result = "";
      switch (type) {
        case "Prepay":
          result = "预付费";
          break;
        case "Postpay":
          result = "后付费";
          break;
        case "Refund":
          result = "退款";
          break;
        case "Adjustment":
          result = "调账";
          break;
        default:
          result = "未知";
      }
      return result;
    },
    eBillStatus(status) {
      let result = "";
      switch (status) {
        case "New":
          result = "新订单";
          break;
        case "Paid":
          result = "已支付";
          break;
        case "Canceled":
          result = "已取消";
          break;
        case "Remove":
          result = "废弃";
          break;
        case "WaitPay":
          result = "待支付";
          break;
        default:
          result = "未知";
      }

      return result;
    },
    eGetTime(time) {
      let result = "";
      let m = moment(time).format("YYYY-MM-DD");
      if (m === "0009-01-01") {
        return result;
      } else if (m === "9999-01-01") {
        return result;
      }
      result = moment(time).format("YYYY-MM-DD HH:mm:ss");
      return result;
    },
    eManualStatus(status) {
      let result = "";
      switch (status) {
        case "Off":
          result = "否";
          break;
        case "On":
          result = "是";
          break;
        default:
          result = "未知";
      }
      return result;
    },
    eGetPaymentInfo() {
      this.$$.api.data
        .find("/kernel/transaction/apis/data/paymentOrder", {
          number: this.paymentOrderSN,
          columns: ["*", "payment.*", "creator.name"],
        })
        .then((res) => {
          let data = res.data.item;
          this.paymenData.bizNumberText = data.bizNumber ? data.bizNumber : "";
          this.paymenData.typeText = data.payment
            ? this.ePaymenType(data.payment.type)
            : "";
          this.paymenData.statusText = data.status
            ? this.ePaymentStatus(data.status)
            : "";
          this.paymenData.amountText = data.amount ? data.amount : "";
          this.paymenData.creatorText = data.creator ? data.creator.name : "";
          this.paymenData.expiredTimeText = data.expiredTime
            ? this.eGetTime(data.expiredTime)
            : "";
          this.paymenData.timeText = data.time ? this.eGetTime(data.time) : "";
          this.paymenData.lastTimeText = data.lastTime
            ? this.eGetTime(data.lastTime)
            : "";
          if (data.payment && data.payment.type == "Offline") {
            this.offlineShow = true;
            this.eGetPaymentOffline();
          }
        });
    },
    ePaymenType(type) {
      let result = "";
      switch (type) {
        case "Offline":
          result = "线下支付";
          break;
        case "Online":
          result = "在线支付";
          break;
        case "Wallet":
          result = "钱包支付";
          break;
        default:
          result = "未知";
          break;
      }
      return result;
    },
    ePaymentStatus(status) {
      let result = "";
      switch (status) {
        case "New":
          result = "新订单";
          break;
        case "Pay":
          result = "开始支付";
          break;
        case "Paid":
          result = "已支付";
          break;
        case "Cancel":
          result = "已取消";
          break;

        default:
          result = "未知";
          break;
      }
      return result;
    },
    eGetPaymentOffline() {
      this.$$.api.data
        .list("/kernel/transaction/apis/data/paymentOrderOffline", {
          columns: ["*", "creator.name"],
          requirement: {
            filters: [
              {
                Name: "PaymentOrderSN",
                Type: "Equal",
                Value: this.paymentOrderSN,
              },
            ],
          },
        })
        .then((res) => {
          let data = res.data.list;
          data.map((p) => {
            this.paymenOrderList.push(p);
          });
        });
    },
    eHandleImageURI(url) {
      let result = "";
      if (url) {
        result = process.env.VUE_APP_API_URL
          ? `${process.env.VUE_APP_API_URL}/` + url
          : url;
      } else {
        result = this.singleDefault;
      }

      return result;
    },
    ePreview(url) {
      this.modalData.addable = true;
      this.modalData.showAdd = true;
      this.modalData.url = url;
    },
    eModalCancel() {
      this.modalData.addable = false;
      this.modalData.showAdd = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.bill_detail {
  padding: 20px;
  > h6 {
    font-weight: 700;
    height: 15px;
  }
  div {
    margin-top: 15px;
  }
}
.cursor_pointer {
  cursor: pointer;
}
.payment_img {
  display: flex;
  align-items: center;
  div {
    width: 70px;
    height: 70px;
    border: 1px solid #efefef;
    box-sizing: border-box;
    display: inline-block;
    background-size: 100% 100%;
  }
}
.image-input-default {
  background: #e6e6e6;
}
.image-input-dashed {
  border: 1px dashed #9e9e9e !important;
  position: relative;
}
</style>